import ContentAudioList from './content/ContentAudioList';
import ContentTVList from './content/ContentTVList';
const AUDIO = 'audio';
const VIDEOS = 'videos';
const MLBTV = 'tv';
const MiLBTV = 'tv';

const mediaTitleMap = {
    Audio: {
        type: AUDIO
    },
    'Extended Highlights': {
        type: VIDEOS,
        key: 'condensed'
    },
    'Daily Recap': {
        type: VIDEOS,
        key: 'recap'
    },
    MLBTV: {
        type: MLBTV
    },
    MiLBTV: {
        type: MiLBTV
    }
};

class ContentModel {
    constructor (data, params) {
        this.data = data || {};
        this.params = params;
        this.parseData(data);
    }

    parseData (data = {}) {
        const { audio = {}, videos = [], recap = {}, tv = {} } = data;
        this.parseVideos(videos);
        this.parseRecap(recap);
        this.parseMedia(audio);
        this.parseMedia(tv);
        this.parseHighlightsByTypes(videos);
    }

    parseVideos (videos = []) {
        const playVideoMap = {};
        for (const video of videos) {
            const {
                guid
            } = video;
            if (guid) {
                playVideoMap[guid] = video;
            }
        }
        this.playVideoMap = playVideoMap;
    }

    parseHighlightsByTypes (highlights) {
        let gameRecap;
        let condensedGame;
        const dataViz = [];
        const filteredHighlights = [];

        highlights?.forEach(highlight => {
            const kwDisplay = highlight?.keywordsDisplay;
            const kwAll = highlight.keywordsAll;
            let isHighlight = true;
            const cloned = { ...highlight };

            if ((!gameRecap || !condensedGame) && kwDisplay && kwDisplay?.length > 0) {
                kwDisplay.forEach(kw => {
                    const val = kw?.value;

                    if (val === 'mlb_recap') {
                        cloned.videoType = 'recap';
                        gameRecap = cloned;
                        isHighlight = false;
                    } else if (val === 'condensed_game') {
                        cloned.videoType = 'condensedGame';
                        condensedGame = cloned;
                        isHighlight = false;
                    }
                });
            }

            if (kwAll && kwAll?.length > 0) {
                kwAll.forEach(kw => {
                    const val = kw?.value;
                    if (val === 'data-visualization') {
                        cloned.videoType = 'dataViz';
                        dataViz.push(cloned);
                        isHighlight = false;
                    }
                });
            }

            if (isHighlight) {
                cloned.videoType = 'highlights';
                filteredHighlights.push(cloned);
            }
        });

        this.highlightsByTypes = {
            highlights: filteredHighlights,
            gameRecap,
            condensedGame,
            dataViz
        };
    }

    parseMedia (media) {
        const len = media?.items?.length || 0;

        if (len > 0) {
            let mediaType;
            let mappedType;
            let i = 0;
            let type;
            let items;

            for (; i < len; i++) {
                mediaType = media?.title;
                items = media.items;
                if (items && items.length && mediaType in mediaTitleMap) {
                    mappedType = mediaTitleMap[mediaType];
                    type = mappedType.type;
                    if (type === AUDIO) {
                        this[type] = new ContentAudioList(items);
                    } else if (type === MLBTV) {
                        this[type] = new ContentTVList(items, mediaType);
                    }
                }
            }
        }
    }

    parseRecap (recap = {}) {
        const {
            slug,
            headline,
            blurb,
            templateUrl,
            id,
            isDataLoaded
        } = recap;
        const linkId = id ? `c-${id}` : slug;
        this.recap = {
            slug,
            headline,
            blurb,
            linkId,
            templateUrl,
            isDataLoaded
        };
    }
}

export default ContentModel;
